const STORAGE_KEY = "module_filters_sorts";

const getAllSettings = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const settings = JSON.parse(saved);
      if (typeof settings === "object" && settings !== null) {
        return settings;
      }
    }
  } catch (error) {
    console.error("Error reading settings from localStorage:", error);
  }
  return {};
};

const saveAllSettings = (settings) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error("Error saving settings to localStorage:", error);
  }
};

export const getModuleSettings = (projectId, moduleKey) => {
  if (!projectId) return {
    filters: {},
    searchTexts: {},
    searchedColumns: [],
    sortField: null,
    sortOrder: "asc"
  };

  const allSettings = getAllSettings();
  const projectSettings = allSettings[projectId] || {};
  return projectSettings[moduleKey] || {
    filters: {},
    searchTexts: {},
    searchedColumns: [],
    sortField: null,
    sortOrder: "asc"
  };
};

export const saveModuleSettings = (projectId, moduleKey, settings) => {
  if (!projectId) return;

  const allSettings = getAllSettings();
  if (!allSettings[projectId]) {
    allSettings[projectId] = {};
  }

  allSettings[projectId][moduleKey] = {
    ...getModuleSettings(projectId, moduleKey), // Keep existing defaults if not provided
    ...settings
  };
  saveAllSettings(allSettings);
};

export const clearModuleSettings = (projectId, moduleKey) => {
  if (!projectId) return;

  const allSettings = getAllSettings();
  if (allSettings[projectId]) {
    delete allSettings[projectId][moduleKey];
    saveAllSettings(allSettings);
  }
};
